/**
 * Cards marked collected / First Owner by hand on the set page, per device.
 * Marking a card collected adds it as a collected player (Done tick) and
 * unmarking deletes it again; a First Owner mark sets or clears the collected player's First Owner flag. Club
 * Import and the collected sync pick the real state up.
 */
import { storage } from "../storage/port";
import { GALLERY_STORAGE_KEYS } from "./keys";
const collectedKey = (setId) => `gallery-done-ticks-${setId}`;
const firstOwnerKey = (setId) => `gallery-first-owner-marks-${setId}`;
const readIds = (key) => {
    try {
        const parsed = JSON.parse(storage.get(key) ?? "[]");
        return Array.isArray(parsed)
            ? parsed.filter((n) => typeof n === "number")
            : [];
    }
    catch {
        return [];
    }
};
export const loadGalleryMarks = (setId) => ({
    collected: readIds(collectedKey(setId)),
    firstOwner: readIds(firstOwnerKey(setId)),
});
export const saveGalleryMarks = (setId, marks) => {
    storage.set(collectedKey(setId), JSON.stringify(marks.collected));
    storage.set(firstOwnerKey(setId), JSON.stringify(marks.firstOwner));
};
export const loadLevelBoughtTicks = () => readIds(GALLERY_STORAGE_KEYS.levelBoughtTicks);
export const saveLevelBoughtTicks = (ids) => storage.set(GALLERY_STORAGE_KEYS.levelBoughtTicks, JSON.stringify(ids));
/** Unmarking collected drops First Owner too: a First Owner card is collected. */
export const toggleCollectedMark = (marks, id) => marks.collected.includes(id)
    ? {
        collected: marks.collected.filter((m) => m !== id),
        firstOwner: marks.firstOwner.filter((m) => m !== id),
    }
    : { ...marks, collected: [...marks.collected, id] };
/** Marking First Owner marks collected too. */
export const toggleFirstOwnerMark = (marks, id) => marks.firstOwner.includes(id)
    ? { ...marks, firstOwner: marks.firstOwner.filter((m) => m !== id) }
    : {
        collected: [...new Set([...marks.collected, id])],
        firstOwner: [...marks.firstOwner, id],
    };
/** One grade's lineup, by item score, then resource id. */
export const sortGalleryItems = (items) => [...items].sort((a, b) => b.score - a.score || a.resourceId - b.resourceId);
//# sourceMappingURL=marks.js.map